import { DownloadK8sAgentController } from '../controller/DownloadK8sAgentController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class DownloadK8sAgentWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DownloadK8sAgentController,
    });
  }
}
